export class HaEditIcdModal {
  id: string;
  name: string;
  category: string;
  description: string;
  parent: string;
  isEditable: boolean;
  type: number;
  helpText: string;
}
